<template>
    <div>
        <breadcrumb />
        <div class="row">
            <main class="col-12 col-lg-9">
                <div class="cw-content-nosidenav">
                    <h1>Registration</h1>
                    <h2>Participant agreement information</h2>

                    <div class="form-row mb-4 mt-4">
                        <div class="col-12 col-sm-4">
                            <label for="participantName"><span>Organization's/participant's name</span></label>
                            <input autocomplete="off" type="text" id="participantName" v-model="participantName" class="form-control form-control-md" />
                        </div>
                    </div>

                    <div class="form-row mb-4 mt-4">
                        <div class="col-12 col-sm-4">
                            <label for="fullName"><span>Full name</span></label>
                            <input autocomplete="off" type="text" id="fullName" v-model="fullName" class="form-control form-control-md" />
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-sm-4">
                            <label for="jobTitle"><span>Job title</span></label>
                            <input autocomplete="off" type="text" v-model="jobTitle" id="jobTitle" class="form-control form-control-md" />
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-sm-4">
                            <label for="jobTitle"><span>Address</span></label>
                            <input autocomplete="off" type="text" v-model="address" id="address" class="form-control form-control-md" />
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-sm-4">
                            <label for="phone"><span>Phone</span></label>
                            <input autocomplete="off" type="text" v-model="phone" id="phone" class="form-control form-control-md" />
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-sm-4">
                            <label for="email"><span>Email</span></label>
                            <input autocomplete="off" type="text" v-model="email" id="email" class="form-control form-control-md" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-primary float-right" @click="nextpage">{{buttonLabel}}</button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>
<script>
    import breadcrumb from '@/components/Breadcrumb';

    export default {
        name: 'participant-info',
        components: {
            breadcrumb
        },
        data: function() {
            return {
                participantName: "",
                fullName: "",
                jobTitle: "",
                address: "",
                phone: "",
                email: "",
                buttonLabel: "Next"
            }
        },
        mounted() {
            let data = this.$store.getters.PARTICIPANT;
            
            if (data.length > 0) {
                let item = data[0];
                this.participantName = item.participantName;
                this.fullName = item.fullName;
                this.jobTitle = item.jobTitle;
                this.address = item.address;
                this.phone = item.phone;
                this.email = item.email;
            }
        },
        methods: {
            nextpage() {
                let nextPage = "ParticipationAgreement";

                let summaryPage = this.$store.getters.SUMMARYPAGE;
                if (summaryPage)
                    nextPage = "Summary";

                if (this.participantName === "") {
                    alert("Organization's/participant's name is mandatory.");
                    return false;
                }
                if (this.fullName === "") {
                    alert("Full name is mandatory.");
                    return false;
                }
                if (this.jobTitle === "") {
                    alert("Job title is mandatory.");
                    return false;
                }
                if (this.address === "") {
                    alert("Address is mandatory.");
                    return false;
                }
                if (this.phone === "") {
                    alert("Phone is mandatory.");
                    return false;
                }
                if (this.email === "") {
                    alert("Email is mandatory.");
                    return false;
                }
                let value = {
                    participantName: this.participantName, fullName: this.fullName,
                    jobTitle: this.jobTitle, address: this.address,
                    phone: this.phone, email: this.email
                };

                this.$store.dispatch("SAVE_PARTICIPANT", value);

                //this.$router.push({ name: 'Detail', params: { parameters: this.contactList } });
                this.$router.push({ name: nextPage });
            }
        }
    }
</script>